import { useDebounce } from '@uidotdev/usehooks';
import type { SnapshotFrom } from 'xstate';

import { RESERVATION_ACTION_BUTTON_DEBOUNCE_MS } from '@/data/constants';

import {
  reservationFormMainMachine,
  selectRequestOverrideButtonDisabled,
  selectSaveAsDraftButtonDisabled,
  selectTripLegNextButtonDisabled,
  type TripLegNextButtonDisabledOptions,
} from '../machines/reservationFormMain.machine';

export type { TripLegNextButtonDisabledOptions };

export function useDebouncedReservationActionSelectors(
  mainSnapshot: SnapshotFrom<typeof reservationFormMainMachine>,
  tripLegNextOptions?: TripLegNextButtonDisabledOptions,
) {
  const rawTripLegNextDisabled = selectTripLegNextButtonDisabled(
    mainSnapshot,
    tripLegNextOptions,
  );
  const rawRequestOverrideDisabled =
    selectRequestOverrideButtonDisabled(mainSnapshot);
  const rawSaveAsDraftDisabled = selectSaveAsDraftButtonDisabled(mainSnapshot);
  const isBusy =
    mainSnapshot.matches('submitting') || mainSnapshot.matches('validating');

  const debouncedTripLegNext = useDebounce(
    rawTripLegNextDisabled,
    RESERVATION_ACTION_BUTTON_DEBOUNCE_MS,
  );
  const debouncedRequestOverride = useDebounce(
    rawRequestOverrideDisabled,
    RESERVATION_ACTION_BUTTON_DEBOUNCE_MS,
  );
  const debouncedSaveAsDraft = useDebounce(
    rawSaveAsDraftDisabled,
    RESERVATION_ACTION_BUTTON_DEBOUNCE_MS,
  );

  return {
    tripLegNextButtonDisabled: isBusy
      ? rawTripLegNextDisabled
      : debouncedTripLegNext,
    requestOverrideButtonDisabled: isBusy
      ? rawRequestOverrideDisabled
      : debouncedRequestOverride,
    saveAsDraftButtonDisabled: isBusy
      ? rawSaveAsDraftDisabled
      : debouncedSaveAsDraft,
  };
}
